<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="名称" prop="roomName">
              <el-input
                v-model="searchForm.roomName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="视频号ID" prop="roomId">
              <el-input
                v-model="searchForm.roomId"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
           
            <el-form-item label="创建人" prop="creator">
              <el-input
                v-model="searchForm.creator"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="编辑时间" prop="updatedTime">
              <q-date-picker startFiled="updateTimeStart" endFiled="updateTimeEnd" v-model="searchForm" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">
              查询
            </el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="handleAddOrEdit">
            新建
          </el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column  prop="roomName" label="名称" align="center"></el-table-column>
          <el-table-column  prop="roomId" label="视频号id" align="center" ></el-table-column>
          <el-table-column  prop="creatorName" label="创建人" align="center"></el-table-column>
          <el-table-column  prop="updatedTime" label="编辑时间" align="center"></el-table-column>
          <el-table-column  prop="updatedTime" label="状态" align="center">
             <template slot-scope="scope">
            {{scope.row.useStatus | useStatus}}
          </template>
          </el-table-column>
          <el-table-column  label="操作"  class-name="action-column" align="center">
            <template slot-scope="scope">
              <template v-if="scope.row.useStatus == 1">
                <el-button type="text" size="small" @click="handleState(scope.row, 0)">上架</el-button>
                <el-button type="text" size="small" @click="handleAddOrEdit(scope.row)">编辑</el-button>
                <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
              </template>
              <el-button  v-else type="text" size="small" @click="handleState(scope.row, 1)">下架</el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <add-dialog
      v-if="isNewAddPopup"
      :isNewAddPopup.sync="isNewAddPopup" 
      :formItems="weChatformItems"
      :editData.sync='editData'
      :title="editData.liveRoomId ? '编辑': '新增'"
      @onConfirm="onConfirm"
    >
    </add-dialog>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import addDialog from './add-dialog.vue'
import moment from 'moment';
import { weChatformItems } from './config'
export default {
  name: "weChat",
  mixins: [tableMixin],
  components: {
    addDialog
  },
  data() {
    return {
      isNewAddPopup: false,
      searchForm: {
        roomName: "",
        roomId: "",
        creator: "",
        updateTimeEnd: "",
        updateTimeStart: "",
      },
      // 表格相关
      tableData: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {
      },
      loading: false,
      weChatformItems,
      editData: {
        remark: '',
        roomName: '',
        roomId: '',
      }
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.configure
        .queryLiveRooms(params)
          .then(({ data: { list, total } }) => {
            this.tableData = list || [];
            this.total = total;
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.updateTimeStart = ''
      this.searchForm.updateTimeEnd = ''
      this.$refs.dateRef.reset()
    },
    handleAddOrEdit(row) {
      if (row) {
        const {roomId,roomName,liveRoomId} = row
        this.editData = { roomId, roomName, liveRoomId, remark:''}
      }
      this.isNewAddPopup = true
    },
    onConfirm() {
      this.$api.configure.wechatAddOrEdit(this.editData)
        .then(res => {
          this.$message({
            message: '保存成功',
            type: 'success'
          });
          this.isNewAddPopup = false
          this.init()
        })
    },
    handleState(row,useStatus) {
      const {liveRoomId} = row
      this.$api.configure.updateUseStatus({liveRoomId,useStatus})
        .then(res => {
          this.$notify.success({
            title: '成功',
            message: '操作成功',
          });
          this.init()
        })
    },
    async handleDelete(row) {
      this.$api.configure.liveRoomDelete(row.liveRoomId).then(res => {
        if (res.success) {
           this.$notify.success({
            title: '成功',
            message: '删除成功',
          });
          this.init()
        }
      })
      
    }
  },
  filters: {
    useStatus(val) {
      const map = {
        0: '上架',
        1: '下架',
      };
      return map[val] || '';
    }
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input
  width 220px !important
</style>
